import React from "react";

import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";

const RadioEl = (props) => (
    <div className={"RadioLegend " + (props.className || "")} title={props.title}>
        <Radio color={props.color || "secondary"} name={props.name} value={props.value} onClick={props.onclick} checked={props.active} disabled={props.disabled || false}/>
        <FormLabel component="legend">{props.label}</FormLabel>
    </div>
)

export default RadioEl;
